import {create} from "zustand";


const useZustand = {
  usePage: create(set=>({
    isPage: 0,
    setIsPage: page=>set({isPage: page})
  })),
}
export default useZustand;